export default "__VITE_ASSET__BjMHq_Od__"